// extracted by mini-css-extract-plugin
module.exports = {"wait":"Loader_wait__3w8Mu","displayTransition":"Loader_displayTransition__1_O8l","icon":"Loader_icon__2GoJs","spin":"Loader_spin__1zRst"};